import YTPlayer from 'yt-player';

export default {
  init() {

  },

  finalize() {
    // Initialise image carousel, where necessary
    if ($('.image-carousel').length > 0) {
      $('.image-carousel').each(function() {
        $(this).owlCarousel({
          items: 1,
          nav: true,
          navText: ['<i class="icon-left-arrow-circle"></i>', '<i class="icon-right-arrow-circle"></i>'],
        });
      });
    }

    // Numbers block view all on mobile
    if ($('.block-numbers').length > 0) {
      $('.block-numbers').each(function() {
        const $this_ = $(this);

        if ($this_.find('.view-all-btn').length > 0) {
          $this_.find('.view-all-btn').on('click', function() {
            $this_.find('.mobile-collapse').stop().slideToggle(600);

            if ($(this).hasClass('all-show')) {
              $(this).find('.view-all-text').html('View all');
              $(this).removeClass('all-show');
            } else {
              $(this).find('.view-all-text').html('View less');
              $(this).addClass('all-show');
            }
          });
        }
      });
    }

    // YouTube player
    if ($('.yt-player').length > 0) {
      $('.yt-player').each(function() {
        const $splashWrap = $(this).siblings('.yt-splash');

        const id = $(this).attr('id');
        const videoId = $(this).data('yt-id');

        const player = new YTPlayer('#' + id);
        player.load(videoId);

        player.on('ended', () => {
          $splashWrap.siblings('.yt-player').addClass('d-none');
          $splashWrap.removeClass('d-none');
        });

        $splashWrap.on('click', function() {
          $(this).siblings('.yt-player').removeClass('d-none');
          $splashWrap.addClass('d-none');
          player.play();
        });

        $splashWrap.on('keydown', function(e) {
          if (e.keyCode == 32 || e.keyCode == 13) {
            $(this).siblings('.yt-player').removeClass('d-none');
            $splashWrap.addClass('d-none');
            player.play();
          }
        })
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-strategic-plan.js